export default "__VITE_PUBLIC_ASSET__053157c3__"